var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success"},[_c('div',{staticClass:"center"},[_c('div',{staticClass:"successImg"}),_c('div',{staticClass:"successText"},[_vm._v(_vm._s(_vm.tipsText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }